<template>
    <div class="bottomBox xy-center">
        <div class="contain xy-between">
            <div class="introuce">
                <p>
                    <span>联系电话：023-63410392</span>
<!--                    <span>电子邮箱：<a href="mailto:muzhe@vipinfo.com.cn" target="_blank">-->
<!--                            muzhe@vipinfo.com.cn-->
<!--                    </a></span>-->
                    <span>联系地址：重庆市两江新区杨柳路重科智谷D座806室</span>
                </p>

                <p>
                    <span>重庆维普朗润数据科技有限公司</span>
                    <!-- <img src="../assets/img/beian.png" alt=""> -->

                    <span>
                        <a
                            href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
                            target="_blank"
                            >渝B2-20050021-1</a
                        >
                        <img src="../assets/img/beian.png" alt="" />
                        <a
                            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50019002500403&from=index"
                            target="_blank"
                            >渝公网备 500000015-00073</a
                        >
                    </span>
                    <span>违法和不良信息举报中心</span>
                </p>
            </div>
<!--            <div class="appDowload jf">-->
<!--                <div class="client yx-center">-->
<!--                    <div class="erweim xy-center">-->
<!--                        <img src="../assets/img/ios.png" alt="" />-->
<!--                    </div>-->
<!--                    <p class="font-size12">-->
<!--                        《医学考典》IOS-->
<!--                    </p>-->
<!--                </div>-->
<!--                <div class="weixin yx-center">-->
<!--                    <div class="erweim xy-center">-->
<!--                        <img src="../assets/img/android.png" alt="" />-->
<!--                    </div>-->
<!--                    <p class="font-size12">-->
<!--                        《医学考典》Android-->
<!--                    </p>-->
<!--                </div>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>
export default {
    props: {},
    data() {
        return {};
    },
    methods: {}
};
</script>

<style lang="less" scoped>
.bottomBox {
    width: 100%;
    height: 200px;
    // background-color: #F2F4F7;
    background-color: #273138;
    bottom: 0;

    .contain {
        width: 62.5%;
        margin: 0 auto;

        .introuce {
            font-size: 14px;
            text-align: center;
            padding: 0 30px;
        }

        .introuce p {
            height: 30px;
            line-height: 30px;
        }

        .introuce p span {
            padding: 0 20px;
        }

        .introuce p span img {
            padding: 0 10px;
        }

        .introuce p span a {
            font-size: 14px;
            color: white;
            text-decoration: none;
        }

        p {
            color: white;
        }

        .appDowload {
            .client {
                margin-right: 20px;
            }

            .erweim {
                width: 100px;
                height: 100px;
                border: 1px solid #4ba5fb;

                img {
                    width: 100px;
                    height: 100px;
                }
            }
        }
    }
}
</style>
